import {
	Vector3,
	BufferGeometry,
	Line
} from 'three';

// draw a line! From point a to b.
// pointCoords contains points a and b
// it's an Array<2>[ Array<3*Number>, Array<3*Number> ]
// material is a THREE.Material
// returns a line, ready to be added to a Scene
// e.g. drawLine( [[0,0,0], [1,1,1]], basicMaterial  ) => Three.Line

export default function drawLine( pointCoords, material ) {
	const points = pointCoords.map( c => new Vector3( ...c ) );
	const geometry = new BufferGeometry().setFromPoints( points );
	const line = new Line( geometry, material );
	return line;
}